module.exports = __webpack_public_path__ + "static/media/person-circle-outline.7c2b115d.svg";